var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-section-wrap"},[_c('common-header',{attrs:{"title":"LIVE","is-back-btn":true,"back-fn":_vm.close,"is-close-btn":false,"go-to-schedule-fn":_vm.goToSchedule,"go-to-reserve-watch-fn":_vm.goToReserveWatch}}),(_vm.catalogData)?_c('WCatalog',{attrs:{"id":_vm.id,"catalog":_vm.catalogData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }